// We can still create subfolders add some component or functionality specific helpers in that folder

import Cookies from 'universal-cookie';

import {
	CITY_COOKIE_TTL,
	CITY_NAME_COOKIE_KEY,
	CITY_ID_COOKIE_KEY,
	ALL_INDIA_CITY_ID,
	ALL_INDIA,
	COOKIE_DOMAIN
} from './constants';


export const getCurrentCity = () => {
	const cookies = new Cookies();
	let cityName, cityCookie;
	if (cookies.get(CITY_NAME_COOKIE_KEY)){
		cityCookie = cookies.get(CITY_NAME_COOKIE_KEY);
		cityName = cityCookie == 'www' ? ALL_INDIA : capitalize(cityCookie);
	}
	else {
		cookies.set(CITY_NAME_COOKIE_KEY, 'www', {
			path: '/',
			maxAge: CITY_COOKIE_TTL,
			domain: COOKIE_DOMAIN
		});
		cookies.set(CITY_ID_COOKIE_KEY, ALL_INDIA_CITY_ID, {
			path: '/',
			maxAge: CITY_COOKIE_TTL,
			domain: COOKIE_DOMAIN
		});
		cityName = ALL_INDIA;
	}
	return cityName;
};

/**
 * Returns the current city, if its not exist it will set the default city(All india) and returns hte id(0)
 * @return {String} [City id]
 */
export const getCurrentCityId = () => {
	const cookies = new Cookies();
	const cityId = cookies.get(CITY_ID_COOKIE_KEY);
	if (cityId && cityId !== '0') {
		return cityId;
	}
	// Setting the cookie if it is not already set
	getCurrentCity();
	return ALL_INDIA_CITY_ID;
};

/**
 * Capitalize first letter of evey word by splitting with different separators
 * @param  {String} string     String to be capitalized
 * @param  {Array}  separators List of separators, with which you want to split the string
 * @return {String}            Capitalized string
 */
export const capitalize = (string, separators = [' ']) => {
	let stringToBeCapitalized = string;
	separators.forEach((separator, index) => {
		stringToBeCapitalized = stringToBeCapitalized.split(separator).map((v, i) => v.charAt(0).toUpperCase() + v.slice(1)).join(separator);
	});
	return stringToBeCapitalized;
};

export const  redirectToPostAd = (e) => {
	window.location = `http://${window.location.host}/post-classifieds-ads`;
};

export const getCookie = (cookieKey) => {
	const cookies = new Cookies();
	return cookies.get(cookieKey);
};

export function formURLSearchObject(data) {
	const result = new URLSearchParams();
	if (typeof data === 'object') {
		Object.keys(data).forEach((key) => { result.append(key, data[key]); });
	}
	return result;
}


// WEBPACK FOOTER //
// ../q-components/helpers/index.js